import './style.scss';
import saveScore from './modules/saveScore';
import successOrErrorMessage from './modules/succesOrErrorMessage';
import renderScores from './modules/renderScores';
import checkGameID from './modules/checkGameID';
import newGameID from './modules/newGameID';
import {
  newGameBtn, newGameName, oldGameBtn, oldGameID, refreshBtn, userName,
  userScore, addScoreBtn, displayID, gameIdSpan, introSection, boardSection,
  startNewGameD, startNewGameM, smallNameError, smallScoreError,
} from './modules/domElements';
import getScores from './modules/getScores';
import { checkInputName, checkInputScore } from './modules/checkInput';

const gameID = checkGameID();
if (gameID !== ' ') {
  renderScores();
}
newGameBtn.addEventListener('click', () => {
  window.localStorage.setItem('Game ID', JSON.stringify(newGameID(newGameName.value)));
  renderScores();
});

oldGameBtn.addEventListener('click', () => {
  getScores(oldGameID.value);
  renderScores();
  gameIdSpan.innerText = oldGameID.value;
  window.localStorage.setItem('Game ID', JSON.stringify(oldGameID.value));
});

userName.addEventListener('change', () => {
  if (checkInputName(userName.value) !== true) {
    smallNameError.innerText = checkInputName(userName.value);
  } else {
    smallNameError.innerText = '';
  }
});

userScore.addEventListener('change', () => {
  if (checkInputScore(userScore.value) !== true) {
    smallScoreError.innerText = checkInputScore(userScore.value);
  } else {
    smallScoreError.innerText = '';
  }
});

addScoreBtn.addEventListener('click', async () => {
  if (checkInputName(userName.value) === true && checkInputScore(userScore.value) === true) {
    const apiReturn = await saveScore(userName.value, userScore.value, gameID);
    successOrErrorMessage(apiReturn);
  }
});

refreshBtn.addEventListener('click', () => {
  renderScores(gameID);
});

startNewGameD.addEventListener('click', () => {
  // introSection.classList.remove('hide');
  // boardSection.classList.add('hide');
  // displayID.classList.add('hide');
  // startNewGameD.classList.add('hide');
  introSection.classList.toggle('hide');
  boardSection.classList.toggle('hide');
  displayID.classList.toggle('hide');
  const textValue = startNewGameD.innerText;
  if (textValue !== 'back') {
    startNewGameD.innerText('back');
  }
});

startNewGameM.addEventListener('click', () => {
  introSection.classList.remove('hide');
  boardSection.classList.add('hide');
  displayID.classList.add('hide');
  startNewGameM.classList.add('hide');
});
